import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
} from "@chakra-ui/react";
import { User } from "features/User/models";
import UpdateRolesForm from "components/Forms/UpdateRolesForm";
import { useIsCurrentUserCompanyAdmin } from "hooks/useCurrentUserPermissions";
import { useUserDetailQuery } from "features/User/hooks";

interface UpdateRolesModalProps {
  userId: string | null;
  onClose: () => void;
  onSuccess?: () => void;
}

export function UpdateRolesModal({ userId, onClose, onSuccess }: UpdateRolesModalProps) {
  const isAdmin = useIsCurrentUserCompanyAdmin();
  const { data: user } = useUserDetailQuery(userId as string, {
    enabled: !!userId && isAdmin,
  });

  const handleSuccess = (resp: any) => {
    onClose();
    onSuccess?.();
  };

  if (!isAdmin) return null;

  return (
    <Modal isOpen={!!userId} onClose={onClose}>
      <ModalContent>
        <ModalHeader>Update Roles</ModalHeader>
        <ModalBody>
          {user && <UpdateRolesForm user={user as unknown as User} onSuccess={handleSuccess} />}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
